import type { WalletTransfersDto } from '@root/shared/api/ServicesApi'

/**
 * The money a wallet has moved.
 *
 * Two limits come with it rather than being inferred. `retainedDays` is how
 * far back anything is kept at all, so an empty list means the history has
 * aged out rather than that the wallet was quiet. And only SOL and
 * stablecoins are indexed — a token moving between two wallets is not here,
 * which no field can say, so the screen says it in words.
 */
export type Transfer = {
  direction: 'in' | 'out'
  /** Who sent it, or who it went to. */
  counterparty: string
  mint: string
  amount: number
  /** Unix milliseconds. */
  at: number
  signature: string
}

export type WalletTransfers = {
  transfers: Array<Transfer>
  retainedDays: number
}

export const fromDto = (dto: WalletTransfersDto): WalletTransfers => ({
  transfers: dto.transfers.map((each) => ({
    direction: each.direction,
    counterparty: each.counterparty,
    mint: each.mint,
    amount: Number(each.amount),
    at: each.at,
    signature: each.signature,
  })),
  retainedDays: dto.retainedDays,
})
